import React from 'react';
import { useNavigate } from 'react-router-dom';

export const AUDIENCE_PATHS = {
  d2c: '/solutions-d2c',
  saas: '/',
};

const OPTIONS = [
  { id: 'd2c', label: 'For D2C Brands' },
  { id: 'saas', label: 'For SaaS' },
];

const AudienceToggle = ({ audience = 'd2c', className = '' }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`inline-flex rounded-full bg-white/40 backdrop-blur-md p-1 shadow-lg ${className}`}
      role="tablist"
      aria-label="Choose your business type"
    >
      {OPTIONS.map((option) => {
        const isActive = audience === option.id;
        return (
          <button
            key={option.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              if (!isActive) navigate(AUDIENCE_PATHS[option.id]);
            }}
            className={`min-w-[6.75rem] sm:min-w-[7.5rem] rounded-full px-4 py-[7px] sm:px-5 sm:py-2 text-[13px] sm:text-sm font-bold tracking-tight transition-all duration-200 ease-out ${
              isActive
                ? 'bg-[#8ae690] text-black shadow-md'
                : 'bg-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default AudienceToggle;
